//@ts-nocheck
// import bags from "../../Assets/bag-icon.svg";
import { useSelector } from "react-redux";
import { FlightLogo, TripType } from "../bookingConfirmation/Utils/Constant";
import { getFlightLogo, titleCase } from "../bookingConfirmation/Utils/CommenFunction";
function BaggageTab(props) {
  var paxType = [];
  const tripTypeValue = useSelector((state) => state.searchForm.tripType);

  props.baggagefares.map((item) => {
    item &&
      item.map((element) => {
        paxType.push(element.paxType);
      });
  });

  var flightNamesArray = [];

  const flightDetails =
    props.flightDetails &&
    Object.values(props.flightDetails)[0] &&
    Object.values(props.flightDetails)[0].flights;

  if (tripTypeValue !== TripType.MULTICITY) {
    flightDetails &&
      flightDetails.map((flight) => {
        flightNamesArray.push({
          flightName: flight.departureAirport + "-" + flight.arrivalAirport,
          carrier: flight.carrier,
          flightNumber: flight.number,
        });
      });
  }

  if (tripTypeValue === TripType.MULTICITY) {
    props.flightDetails &&
      props.flightDetails.map((flight) => {
        let flights = flight && Object.values(flight)[0].flights;
        flights &&
          flights.map((flight) => {
            flightNamesArray.push({
              flightName: flight.departureAirport + "-" + flight.arrivalAirport,
              carrier: flight.carrier,
              flightNumber: flight.number,
            });
          });
      });
  }

 

  return (
    <>
      <div className="fd-baggage">
        {flightNamesArray &&
          flightNamesArray.map((flight, flightIndex) => {
            let flightData;

            if (tripTypeValue !== TripType.MULTICITY) {
              flightData = flightDetails.find(
                (obj) => obj.number === flight.flightNumber
              );
            } else {
              flightData = props.flightDetails.find(
                (obj) => obj.number === flight.flightNumber
              );
            }

            const baggagefaresObject =
              props.baggagefares && props.baggagefares[0]
                ? props.baggagefares[flightIndex]
                : flightData && flightData.fareBasisDetails;
           
            let carrierCode = flight && flight.carrier && flight.carrier
            let flightLogo = getFlightLogo(carrierCode)
            return (
              <>
                <div className="fd-baggage-flight">
                  <img src={flightLogo} alt="flight img" />
                  {flight && flight.flightName} (
                  {flight && flight.carrier + " " + flight.flightNumber})
                </div>

                <div className="fdb-table-head">
                  <div className="fdb-th-col fdb-type-head">Type</div>
                  <div className="fdb-th-col fdb-checkin-head">Check-in</div>
                  <div className="fdb-th-col fdb-addiBag-head">
                    Additional Bags<span>(up to 62 in x 158 cms )</span>
                  </div>
                </div>

                {baggagefaresObject &&
                  baggagefaresObject.map((item) => {
                    const count =
                      item &&
                      item.chargedBaggageDetails &&
                      item.freeBaggageDetails
                        ? item.chargedBaggageDetails.length >
                          item.freeBaggageDetails.length
                          ? item.chargedBaggageDetails.length
                          : item.freeBaggageDetails.length
                        : baggagefaresObject.length;
                    let cntArray = [];
                    let i = 0;
                    while (i !== count) {
                      cntArray.push(i);
                      i++;
                    }

                    let baggageData;
                    if (
                      item.freeBaggageDetails &&
                      item.freeBaggageDetails[0] &&
                      item.freeBaggageDetails[0].quantity
                    ) {
                      baggageData =
                        item.freeBaggageDetails[0].quantity + " Piece";
                    } else if (item.freeBaggage && item.freeBaggage.quantity) {
                      if (item.freeBaggage.quantity === 0) {
                        baggageData = item.freeBaggage.weight + " KG";
                      } else if (
                        item.freeBaggage.quantity === 0 &&
                        item.freeBaggage.weight === 0
                      ) {
                        baggageData = item.freeBaggage.quantity + " Piece";
                      } else {
                        baggageData = item.freeBaggage.quantity + " Piece";
                      }
                    }

                    if (
                      item.freeBaggageDetails &&
                      item.freeBaggageDetails[0] &&
                      item.freeBaggageDetails[0].weight &&
                      item.freeBaggageDetails[0].weight !== 0
                    ) {
                      baggageData = item.freeBaggageDetails[0].weight + " KG";
                    }
                    
                    return (
                      <>
                        {
                          <div className="fdb-table-item">
                            <div className="fdb-tb-type">{item.paxType}</div>
                            <div className="fdb-tb-type">{baggageData}</div>

                            <div className="fdb-tb-chekBag">
                              {cntArray &&
                                cntArray.length > 0 &&
                                cntArray.map((index) => {
                                  let bagCount = [];
                                  let j = 0;
                                  while (j !== index + 1) {
                                    bagCount.push(j);
                                    j++;
                                  }

                                  if (item.chargedBaggageDetails) {
                                  }
                                  let amount =
                                    item.chargedBaggageDetails &&
                                    item.chargedBaggageDetails[index] &&
                                    item.chargedBaggageDetails[index].amount;
                                  let desc =
                                    item.chargedBaggageDetails &&
                                    item.chargedBaggageDetails[index] &&
                                    item.chargedBaggageDetails[index]
                                      .chargeDescription &&
                                    item.chargedBaggageDetails[index]
                                      .chargeDescription[index];
                                  let quantity =
                                    item.chargedBaggageDetails &&
                                    item.chargedBaggageDetails[index] &&
                                    item.chargedBaggageDetails[index]
                                      .firstPiece;

                                     
                                      let additionalBagDesc = desc;
                                      const mapObj = {
                                        POUNDS: "lbs",
                                        KILOGRAMS: "Kgs",
                                        LINEAR:"",
                                        INCHES:"In",
                                        CENTIMETERS:"cms"
                                        
                                      };
                                      additionalBagDesc = additionalBagDesc && additionalBagDesc.replace(/\b(?:POUNDS|KILOGRAMS|LINEAR|INCHES|CENTIMETERS)\b/gi, matched => mapObj[matched]);
                                      
                                 
                                  return (
                                    <>
                                      <div className="fdb-tr">                                     
                                        <span className="fdb-count">{quantity && quantity + " Piece"}</span>
                                        <span className="fdb-details">
                                        {amount ? (
                                          <><strong>$ {amount}</strong> </>
                                        ) : (
                                          <> - </> 
                                        )}
                                        <>{additionalBagDesc && titleCase(additionalBagDesc)}</>  
                                        </span>                                    
                                      </div>
                                    </>
                                  );
                                })}
                            </div>
                          </div>
                        }
                      </>
                    );
                  })}
              </>
            );
          })}
      </div>
    </>
  );
}

export default BaggageTab;
